// Vendors
import { useEffect, useMemo, useState } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Event Handlers
import { BackgroundHandlers } from '../handlers/background.handlers';
import { LogHandlers } from 'handlers/log.handlers';
// Types
import { BackgroundHookType } from './types/background.hook.type';

const useBackgroundHook = (): BackgroundHookType => {
  const [showBackgroundModal, setShowBackgroundModal] = useState<boolean>(false);

  const { currentState } = useAppContextConsumerHook();

  const { handleSendCustomActionEvent } = LogHandlers(),
    { handleWatchBrowserNativeEventsOutEvent, handleRemoveBrowserNativeEventsWatchersEvent } =
      useMemo<ReturnType<typeof BackgroundHandlers>>(
        () =>
          BackgroundHandlers({ currentState, handleSendCustomActionEvent, setShowBackgroundModal }),
        [currentState, setShowBackgroundModal]
      );

  useEffect(() => {
    handleWatchBrowserNativeEventsOutEvent();
    return handleRemoveBrowserNativeEventsWatchersEvent;
  }, []);

  return {
    showBackgroundModal,
    setShowBackgroundModal,
  };
};

export { useBackgroundHook };
